/**
 * This file contains all the error messages that are used in the application.
 */

/**
 * @description Error messages
 * @returns {Record<string, string>} Error messages
 */
export const ERROR_MESSAGES = {};
